import { StyledWrapper, TextArea } from '@blueprint/text-input';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Checkbox } from '@blueprint/checkbox';
import { Button } from '@blueprint/button';
import { Text } from '@blueprint/text';

export const EmailAgentStyledForm = styled('form')(
    ({ theme: { spacing, colors } }) => css`
        display: flex;
        flex-direction: column;
        padding-bottom: ${spacing['16px']};

        ${DropdownWrapper}, ${StyledWrapper}, ${Checkbox} {
            margin-bottom: ${spacing['24px']};
        }

        ${TextArea} {
            padding-top: ${'1.625rem'};
        }

        ${Checkbox} {
            background-color: ${colors['graphic-background']};
            margin-top: ${spacing['24px']};
        }

        ${Button} {
            margin: ${spacing['16px']} 0;
            width: 100%;
        }
    `
);

export const TermsText = styled(Text)(
    ({ theme: { mq, spacing } }) => css`
        margin-bottom: ${spacing['16px']};
        ${mq.large} {
            text-align: center;
        }
    `
);

export const ErrorMessage = styled(Text)(
    ({ theme: { colors, spacing } }) => css`
        color: ${colors['function-error']};
        margin-bottom: ${spacing['16px']};
    `
);

export const CaptchaWrapper = styled('div')(
    ({ theme: { spacing } }) => css`
        margin-bottom: ${spacing['16px']};
    `
);

type DropdownWrapperProps = {
    isError: boolean;
};

export const DropdownWrapper = styled('div')<DropdownWrapperProps>(
    ({ isError }) => {
        return css`
            margin-bottom: ${isError ? '1rem' : '0'};
            position: relative;

            select + span {
                position: relative;
            }
        `;
    }
);
